import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    overflow: 'auto',
  },
  divider: {
    marginRight: theme.spacing(1.5),
  },
}))

export default useStyles
